import { Editor } from '@tinymce/tinymce-react'
import { useEffect, useRef } from 'react'

/**
 * Builder'ın zengin metin alanı.
 *
 * Araç çubuğu bilinçli olarak dar tutulmuştur: v2 motoru HTML'i OOXML'e çevirirken yalnız bu alt kümeyi
 * güvenle destekliyor. Toolbar'a yeni bir buton eklemeden önce motorun (HtmlBlockWriter) o etiketi
 * çevirebildiğinden emin ol.
 *
 * `registerInsert` ile dışarıya bir "imlece metin ekle" fonksiyonu verir; placeholder paleti bunu kullanır.
 */
export default function RichText({ value, onChange, height = 200, apiKey = '', registerInsert, disabled }) {
    const editorRef = useRef(null)

    useEffect(() => () => { if (registerInsert) registerInsert(null) }, [registerInsert])

    return (
        <Editor
            apiKey={apiKey || undefined}
            value={value || ''}
            disabled={disabled}
            onEditorChange={(html) => onChange(html)}
            onInit={(_, editor) => {
                editorRef.current = editor
                if (registerInsert) registerInsert((text) => editor.insertContent(text))
            }}
            init={{
                height,
                menubar: false,
                statusbar: false,
                branding: false,
                language: 'tr',
                plugins: 'lists table link',
                toolbar:
                    'undo redo | bold italic underline | alignleft aligncenter alignright alignjustify | ' +
                    'bullist numlist | outdent indent | removeformat',
                // Motor tarafında desteklenmeyen etiketler baştan engellenir.
                valid_elements:
                    'p[style],br,strong/b,em/i,u,span[style],ul,ol,li,h1,h2,h3,h4,h5,h6,' +
                    'table[border|style],thead,tbody,tr,td[colspan|rowspan|style],th[colspan|rowspan|style],a[href]',
                content_style: 'body { font-family: "Times New Roman", serif; font-size: 12pt; }',
            }}
        />
    )
}
